import { makeStyles } from '@mui/styles';
import { NextTheme } from '../../../../../../ui/layout/theme-next/provider';

export default makeStyles<NextTheme>((theme) => ({
  root: {
    pointerEvents: 'none',
  },
  container: {
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
  },
  paper: {
    pointerEvents: 'auto',
    maxWidth: theme.spacing(40),
  },
  close: {
    margin: theme.spacing(-0.5),
  },
  content: {
    padding: 0,
  },
  actions: {
    padding: 0,
    backgroundColor: theme.palette.common.white,
  },
}));
